<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="mode === 'guest' ? 'Message a Guest' : 'New Message'"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (windowService.isDesktopRes) {
    <tidy-loading-bar class="js-tidy-loading" />
  }
  <tidy-wrapper>

    @if (mode === 'pros') {

      <tidy-card>
        <tidy-card-button (action)="switchToGuestMode()">
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="'assets/svg/person-add-outline.svg'" class="header-size" />
            <tidy-text [header]="'Message a Guest'" />
          </tidy-row>
        </tidy-card-button>
      </tidy-card>

      @for (pro of proList; track pro) {
        <tidy-card>
          <tidy-card-button (action)="goToMessageThread(pro)">
            <tidy-row class="vertical-align-center">
              <tidy-initials-icon
                [fullName]="pro.viewValue" />
              <tidy-text
                [header]="pro.viewValue" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }

    } @else {

      <tidy-row>
        <tidy-text [helper]="'Start a conversation with a guest — even if they haven\'t messaged you yet.'" />
      </tidy-row>
      <tidy-card>
        <tidy-guest-picker
          [submitted]="guestSubmitted"
          (valueChange)="onGuestChange($event)" />
        <tidy-row style="padding-top: 1rem;">
          <tidy-button
            [text]="'Message Guest'"
            class="primary"
            [disabled]="!selectedGuestValue"
            [action]="boundMessageGuest" />
        </tidy-row>
      </tidy-card>
      <tidy-row [align]="'center'">
        <tidy-text
          [actionBody]="'Message a pro instead'"
          (action)="switchToProsMode()"
          class="link" />
      </tidy-row>

    }

  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
